
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import RegisterText from './agreement/registerText.vue';

export default {
directives: {
TransferDom,
},
components: {
Group,
XInput,
XButton,
XDialog,
RegisterText
},
name: 'register',
data () {
return {
showDialog: false,
agreeBtnFlag: true,//弹窗按钮为关闭还是同意
userName: '',
ide: '',
movePhone: '',
isCheck: false,
phoneCheck: false,
ideCheck: false,
weiCheck: false,
weixinNo: '',
email: '',
emailCheck: false,
}
},






created(){
},
activated(){
this.checkEspStatus();
},
computed: {
isFill: function () {

return this.userName != '' && this.phoneCheck && this.isCheck == true 
}
},

methods: {
weixinCheck () {
if (!this.weixinNo) {
this.weiCheck = false;
return;
}
var re = /^[a-zA-Z0-9]([-_a-zA-Z0-9]{5,19})+$/;
if (!re.test(this.weixinNo)) {
this.weiCheck = false;
this.$vux.confirm.show({content:"请输入正确的微信号！", showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
return;
}
this.weiCheck = true;
},

beforeRouteLeave(to, from, next){
to.meta.keepAlive = true
next()
},

getImage(id) {
return require(`@/assets/images/${id}.png`);
}
,
doShowToast() {
this.showDialog = true;
this.agreeBtnFlag = false
},

checkEspStatus() {
const openId = window.sessionStorage.getItem("openId");
if (!openId) {
return;
}
const url = '/wechat/queryUser.do?openId=' + openId;
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code !== 200) {
return;
}
let wechatInfo = response.data.result || {};
let status = wechatInfo.espstatus;
if (status === '1' || status === '3') {

if (wechatInfo.certificationUrl) {
window.location.href = wechatInfo.certificationUrl;
}
} else if (status === '2') {

this.$router.push({path: '/personInfo'}).catch(err => {err});
}

});
},
submitInformation() {

if (!this.movePhoneCheck()) {
return;
}
if (!this.userName) {
this.$vux.confirm.show({content: "姓名不能为空", showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
return;
}




this.$emit('confirm');
this.$router.push({
path: '/UploadCard',
query: {userName: this.userName, movePhone: this.movePhone}//, ide: this.ide}
}).catch(err => {err});



},

movePhoneCheck() {

const movePhone = this.movePhone;
if (!movePhone || movePhone === '') {

this.$vux.confirm.show({content:"手机号不能为空", showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
this.phoneCheck = false;
return false
}
const phoneReg = /^\d{11}$/
if (!phoneReg.test(movePhone)) {

this.$vux.confirm.show({content:"请输入正确的11位手机号", showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
this.phoneCheck = false;
return false
}
this.phoneCheck = true;
return true;
},
checkChange(){
if (this.isCheck) {
this.isCheck = false;
} else {
this.doShowToast();
this.agreeBtnFlag = true
}
},

checkIde () {
var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
if (!idcardReg.test(this.ide)) {
this.$vux.confirm.show({content:"输入的身份证号长度不对，或者号码不符合规定！15位号码应全为数字，18位号码末位可以为数字或X", showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
this.ideCheck = false;
return;
}
this.ideCheck = true;
},
checkEmail () {
if (!this.email) {
this.emailCheck = false;
return;
}
let mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
if (!mailReg.test(this.email)) {
this.$vux.confirm.show({content:"请输入正确的邮箱账号", showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
this.emailCheck = false;
return;
}
this.emailCheck = true;
}

},
beforeDestroy () {
clearInterval(this.interval)
},
}



// WEBPACK FOOTER //
// ./src/pages/register.vue